import fileDownload from "js-file-download";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { postPosterPdfCombinedError, postPosterPdfCombinedSuccess } from "../../actions";
import actionTypes from "../../actions/actionTypes"
import { FLYER, NEWSPAPER, WEEKPOSTER, WEEKPROGRAMFLYER } from "../../constants/printType";
import { FEATURES, PRINT_TYPES_DATA } from "../../constants/state";
import createUrlFromIds from "../../functions/createUrlfromIds";
import getData from "../../functions/getData";
import { postCombinedPosterPdfCall } from "../../apis/printApi/postCombinedPosterPdfCall"


const PRINT_API_BASE_URL = pmkinoClientVars.printHeadlessChromeServiceURL


const formatIDSelector = (format, printType) => (state) => ({
    formatIds: getData(state, [PRINT_TYPES_DATA, printType, 'allFormats', format,'items']).toJS()
})

const baseUrlSelector = (state) => ({
    baseURL: state.getIn(['wpServerData', 'data', 'data', 'site', 'url_site'])
})

const renderSleepSetting = (state) => ({
    renderSleep: state.getIn(['wpServerData', 'data', 'data', 'features', 'rendersleep_setting'])
})


function* postPosterPdfCombined(action) {
    try {
        const { printFormatState, printFormat, landscape,  activeWeek, printType, cinemaId, printPk } = action.payload
        const { formatIds } = yield select(formatIDSelector(printFormatState, printType));
        const { baseURL } = yield select(baseUrlSelector)
        const { renderSleep } = yield select(renderSleepSetting)

        if(!cinemaId) {
            throw new Error('No Cinema Id')
        }

        let urls
        let margin

        if(printType === WEEKPOSTER) {
            const queryString = createUrlFromIds(formatIds)
            urls = [`${baseURL}/pmkinoprint/print/#/${cinemaId}/${printType}/${printFormat}/${printPk}/${landscape}/${activeWeek}/${queryString}`]
            margin = {
                top: '4mm',
                right: '4mm',
                bottom: '4mm',
                left: '4mm'
            }
        } else if(printType === FLYER) {
            urls = [`${baseURL}/pmkinoprint/print/#/${cinemaId}/${printType}/${printFormat}/${printPk}/${landscape}/${activeWeek}`]
            margin = {
                top: '0mm',
                right: '0mm',
                bottom: '0mm',
                left: '0mm'
            }
        } else if(printType === NEWSPAPER) {
            urls = [`${baseURL}/pmkinoprint/print/#/${cinemaId}/${printType}/${printFormat}/${printPk}/${landscape}/${activeWeek}`]
            margin = {
                top: '0mm',
                right: '0mm',
                bottom: '0mm',
                left: '0mm'
            }
        } else if(printType === WEEKPROGRAMFLYER) {
            urls = [`${baseURL}/pmkinoprint/print/#/${cinemaId}/${printType}/${printFormat}/${printPk}/${landscape}/${activeWeek}`]
            margin = {
                top: '0mm',
                right: '0mm',
                bottom: '0mm',
                left: '0mm'
            }
        } else {
            urls = formatIds.map((id) => {
                return `${baseURL}/pmkinoprint/print/#/${cinemaId}/${printType}/${printFormat}/${printPk}/${landscape}/${activeWeek}/${id}` 
            })
            margin = {
                top: '4mm',
                right: '4mm',
                bottom: '4mm',
                left: '4mm'
            }
        }


        const response = yield call(postCombinedPosterPdfCall, PRINT_API_BASE_URL, urls, printFormat, landscape, margin, printType, renderSleep)
        var base64str = response.data;
        // decode base64 string, remove space for IE compatibility
        var binary = atob(base64str.replace(/\s/g, ''));
        var len = binary.length;
        var buffer = new ArrayBuffer(len);
        var view = new Uint8Array(buffer);

        for (var i = 0; i < len; i++) {
            view[i] = binary.charCodeAt(i);
        }

        // create the blob object with content-type "application/pdf"               
        var blob = new Blob( [view], { type: "application/pdf" });
        var url = URL.createObjectURL(blob);


        if(printType === FLYER) {
            fileDownload(view, "flyer.pdf")
        } else if(printType === WEEKPROGRAMFLYER) {
            fileDownload(view, "weekprogram.pdf")
        } else {
            fileDownload(view, "showcase_posters.pdf")
        }
        yield put(postPosterPdfCombinedSuccess());
    } catch(e) {
        console.log('ERROR', e)
        yield put(postPosterPdfCombinedError(e.message))
    }
}



function* watchPdfRequest() {
    yield takeLatest(actionTypes.POST_POSTER_PDF_COMBINED_REQUEST, postPosterPdfCombined)
}

export default watchPdfRequest